import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "./EventDetail.css";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const SchoolEventDetail = () => {
  const { school_slug, eventId } = useParams();
  const baseUrl = school_slug ? `/${school_slug}` : "";
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await fetch(
          `${baseAPIUrl}admin/life_at_tigps/individual_events/${eventId}`
        );

        const result = await res.json();

        if (!res.ok || result.status !== 1 || !result.data) {
          throw new Error("Event not found");
        }

        const apiEvent = result.data;

        /* 🔁 NORMALIZE DATA */
        const formattedEvent = {
          id: apiEvent.id,
          title: apiEvent.event_name,
          date: apiEvent.event_date,
          fullDescription: apiEvent.event_content,
          gallery: Array.isArray(apiEvent.images)
            ? apiEvent.images.map(img =>
              `${baseAPIUrl}assets/images/events/${img.image_name}`
            )
            : [],
        };
        console.log(apiEvent);

        setEvent(formattedEvent);
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    if (eventId) {
      fetchEvent();
    }
  }, [eventId]);

  const goToLifeAtTIGPSSection = (e, sectionId) => {
    e.preventDefault();              // ⛔ stop Link default
    e.stopPropagation();             // ⛔ stop dropdown toggle

    navigate(`/${school_slug}/life-at-tigps`, {
      state: { scrollTo: sectionId }
    });
  };

  /* ------------------ STATES ------------------ */

  if (loading) {
    return (
      <div className="container content-section" style={{ padding: '80px 20px' }}>
        <h2 style={{ textAlign: 'center', fontFamily: 'Lora', fontSize: '2.5rem', }}>Event data loading ...</h2>
      </div>
    );
  }

  if (error || !event) {
    return (
      <div className="container content-section" style={{ padding: '80px 20px' }}>
        <h2 style={{ textAlign: 'center', fontFamily: 'Lora', fontSize: '2.5rem', }}>Event not found</h2>
        <Link onClick={(e) => goToLifeAtTIGPSSection(e, "celebratory-events")} className="back-to-events-btn">
          ← Back to Events
        </Link>
      </div>
    );
  }

  /* ------------------ UI ------------------ */

  return (
    <div className="event-detail">
      <div className="container">

        <nav className="breadcrumb-nav">
          <Link to={baseUrl || "/"}>Home</Link>
          <span>/</span>
          <Link to={`/${school_slug}/life-at-tigps`}>Life at TIGPS</Link>
          <span>/</span>
          <span>{event.title}</span>
        </nav>

        <div className="event-content">
          <div className="event-header">
            <h1 className="event-title">{event.title}</h1>
            {event.date && <p className="event-date">{event.date && event.date !== "0000-00-00"
              ? event.date
              : ""}</p>}
          </div>

          <div className="event-description">
            <p>{event.fullDescription}</p>
          </div>

          {/* GALLERY */}
          {event.gallery.length > 1 ? (
            <div className="event-gallery">
              <h3>Gallery</h3>
              <div className="gallery-carousel">
                <div className="gallery-track">
                  {[...event.gallery, ...event.gallery].map((img, index) => (
                    <div key={index} className="gallery-slide">
                      <img src={img} alt={`${event.title} ${index + 1}`} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : event.gallery.length === 1 ? (
            <div className="row single-image-layout">
              <div className="col-lg-8">
                <div className="event-info">
                  <h4 style={{color: 'rgb(100, 19, 32)', fontSize: '1.1rem'}}>Event Information</h4>
                  <div className="info-item">
                    <strong>Date:</strong> {event.date && event.date !== "0000-00-00"
                      ? event.date
                      : ""}
                    <br />
                    <strong>Category:</strong> {event.title}
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <img
                  src={event.gallery[0]}
                  alt={event.title}
                  className="single-event-image"
                />
              </div>
            </div>
          ) : (
            <div className="event-info">
              <h4>Event Information</h4>
              <div className="info-item">
                <strong>Date:</strong> {event.date && event.date !== "0000-00-00"
                  ? event.date
                  : ""}
                <br />
                <strong>Category:</strong> {event.title}
              </div>
            </div>
          )}

          <Link onClick={(e) => goToLifeAtTIGPSSection(e, "celebratory-events")} className="back-to-events-btn">
            ← Back to Events
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SchoolEventDetail;
